
<template>
    <div class="ship-date-picker" :class="{'invalid': !dateIsValid}">
        <datepicker
            v-if="estimatedShipDateObj && lastDisallowedShipDate"
            v-model="estimatedShipDateObj"
            class="ship-date"
            :format="DATE_FORMAT"
            :disabled-dates="{ to: lastDisallowedShipDate }"
        ></datepicker>
        <div class="invalid-feedback">Please select a valid date</div>
    </div>
</template>

<script>
/**
 * Shipping Date Picker Component
 * Uses a DatePicker component and adheres to Suncast's shipping date rules
 *
 * @author Kevin Jones (Fresche Solutions)
 * @date November 2020
 */
import { mapState, mapGetters, mapMutations, mapActions } from "vuex";
import Datepicker from "vuejs-datepicker";
import Dates from "../../../../services/dates";

export default {
    name: "ShipDatePicker",
    components: {
        Datepicker,
    },
    data() {
        return {
            DATE_FORMAT: "yyyy-MM-dd",

            lastDisallowedShipDate: null,
            estimatedShipDateObj: null,
            dateIsValid: true,
        };
    },
    props: {
        shipDate: {
            required: true,
            type: String,
            default: '',
        },
    },
    async mounted() {
        this.init();
    },
    watch: {
        // Convert the Estimated Ship Date to a date string from the Date object we've been working with.
        // Need to require this.activeOrder in case the user refreshes the page because it won't get the order.
        estimatedShipDateObj: {
            immediate: true,
            handler(route) {
                if (this.estimatedShipDateObj) {

                    let estimatedShipDate = Dates.getDateFromDateObject(this.estimatedShipDateObj);
                    this.$emit('date-selected', estimatedShipDate);

                    this.dateIsValid = (this.estimatedShipDateObj.getTime() > this.lastDisallowedShipDate.getTime());
                }
            }
        }
    },
    methods: {
        ...mapActions("Order", ["fetchEstimatedShipDate"]),
        ...mapGetters("Order", ["getEstimatedShipDate"]),

        async init() {

            // Get estimated ship date as a Date object - every time
            await this.fetchEstimatedShipDate();
            let earliestShipDate = this.getEstimatedShipDate();

            // Set requested ship date to either what was passed in or to the date we just fetched
            let estimatedShipDate = (this.shipDate && this.shipDate != '' ? this.shipDate : earliestShipDate);
            this.estimatedShipDateObj = Dates.getDateObject(estimatedShipDate);

            // Get the earliest estimated ship date Date object from the Estimated Ship Date
            // and set the last disallowed date to the day before
            this.lastDisallowedShipDate = Dates.getDateObject(earliestShipDate);
            this.lastDisallowedShipDate.setDate(this.lastDisallowedShipDate.getDate() - 1);
        },
    }
};
</script>

<style>
    .ship-date-picker.invalid input {
        border-color: #e55353;
    }
    .ship-date-picker.invalid .invalid-feedback {
        display: inline-block;
        color: #e55353;
    }
</style>
